"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var material_1 = require("@mui/material");
var Send_1 = __importDefault(require("@mui/icons-material/Send"));
var helpers_1 = require("@/frontend/helpers");
var useIsSmallScreen_1 = __importDefault(require("@/frontend/react/hooks/useIsSmallScreen"));
var trans_1 = __importDefault(require("@/plugins/trans"));
var ConnectionStyles_1 = require("@/frontend/react/connections/ConnectionStyles");
var MessageContext_1 = __importDefault(require("../../context/MessageContext"));
function SendMessageBox(_a) {
    var chatId = _a.chatId;
    var isSmallScreen = (0, useIsSmallScreen_1.default)();
    var _b = (0, react_1.useState)(''), message = _b[0], setMessage = _b[1];
    var _c = (0, react_1.useState)(false), sending = _c[0], setSending = _c[1];
    var newMessage = (0, react_1.useContext)(MessageContext_1.default).newMessage;
    var sendMessage = function () {
        if (sending) {
            return false;
        }
        setSending(true);
        return axios_1.default
            .post("/data/message/".concat(chatId), { content: message })
            .then(function (data) { return newMessage(data.data); })
            .finally(function () {
            setSending(false);
            setMessage('');
        });
    };
    var handleKeyDown = function (event) {
        if ((0, helpers_1.isCtrlEnter)(event)) {
            sendMessage();
        }
    };
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ id: "messageBox", sx: isSmallScreen ? ConnectionStyles_1.messageBoxStyles.mobile : ConnectionStyles_1.messageBoxStyles.desktop }, { children: [(0, jsx_runtime_1.jsx)(material_1.TextField, { placeholder: "".concat(trans_1.default.get('entities.message'), "..."), variant: "filled", sx: { flexGrow: 1, padding: { xs: 0, md: '1rem 0 1rem 1rem' } }, multiline: true, value: message, onChange: function (event) { return setMessage(event.target.value); }, onKeyDown: handleKeyDown }), (0, jsx_runtime_1.jsx)(material_1.IconButton, __assign({ sx: ConnectionStyles_1.messageBoxStyles.sendButton, color: "primary", disabled: sending, onClick: sendMessage }, { children: (0, jsx_runtime_1.jsx)(Send_1.default, {}) }))] })));
}
exports.default = SendMessageBox;
